define([
	'jquery',
	'domReady',
	'pubsub',
	'promise!wcs.zmetrics'
	], function($, domReady, pubsub) {

	if(WCS_CONFIG.get('ANALYTICS::cmEnabled')) {
		if(window.manualImpressionParameters) {
			domReady(function() {
				$('.find-store-js').on('click', function(e) {
					cmCreateManualImpressionTag(
						window.manualImpressionParameters.pageID,
						window.manualImpressionParameters.sitePromotion,
						window.manualImpressionParameters.realEstate
					);
				});
			});
		}

		$.pubsub('subscribe', 'WCS.PRODUCTFORM.EVENT.ONLINEDEALER.ACTIVE', function() {
			var partNumber = $('.product-form-js input[name="productCode"]').val(),
				bfdImpressionParameters = {
					pageID: (typeof cm_pageView_pageId === "undefined") ? document.title : cm_pageView_pageId,
					sitePromotion: 'PDP-_-BuyFromDealer-_-' + partNumber,
					realEstate: null
				}; 

			cmCreateManualImpressionTag(
				bfdImpressionParameters.pageID,
				bfdImpressionParameters.sitePromotion,
				bfdImpressionParameters.realEstate
			);
		});
	}
});